export const MUNICIPAL_PROPERTY_LIST_PAGE_SIZE = {
    default: 50,
    max: 100,
};
